import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, computed, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Store } from '@ngxs/store';
import { forEach } from 'lodash';
import { DocumentUploadButtonComponent } from 'ng2-app/components/document-upload/document-upload-button.component';
import { TooltipIfClampedDirective } from 'ng2-app/directives/tooltip-if-clamped.directive';
import { Contact } from 'ng2-app/models/dto/contact.model';
import { Document } from 'ng2-app/models/dto/document.model';
import { LetDirectiveModule } from 'ng2-app/modules/directives/let/let.directive.module';
import { BorrowerState } from 'ng2-app/store/borrower/borrower/borrower.state';
import { PushToFlashSpread, UpdateDocument, UploadDocument } from 'ng2-app/store/documents/document.actions';
import { DocumentState } from 'ng2-app/store/documents/document.state';

export interface DscrDocRequirement {
  year: number | string;
  documentData?: Document;
}

@Component({
  selector: 'app-dscr-doc-requirement',
  standalone: true,
  templateUrl: 'dscr-doc-requirement.component.html',
  imports: [
    CommonModule,
    DocumentUploadButtonComponent,
    LetDirectiveModule,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    TitleCasePipe,
    TooltipIfClampedDirective,
  ],
})
export class DscrDocRequirementComponent {

  borrowerId = toSignal( this.store.select( BorrowerState.borrowerId ) );
  documentStateLoading = toSignal( this.store.select( DocumentState.loadingOrUploading ) );
  requirementStatusClass = computed(() => {
    const document = this.requirement.documentData;
    const flashSpreadStatus = document?.flash_spread_data?.status;
    const color = !document ? 'red' : flashSpreadStatus === 'completed' ? 'green' : 'yellow';
    return `tw-text-lendio-${color}-500`;
  });
  flashSpreadStatus = computed(() => {
    const status = this.requirement?.documentData?.flash_spread_data?.status;
    return !!status
      ? status === 'pendingValidationReview'
        ? 'Pending Validation Review'
        : this.titleCasePipe.transform(status)
      : '';
  });

  @Input() contact?: Contact;
  @Input() ownerDocumentsWithNoYear?: Document[];
  @Input({required: true}) category: string;
  @Input({required: true}) requirement: DscrDocRequirement;
  @Input({required: true}) borrowerDocuments: Document[];

  handleUpload: any;

  constructor(
    private store: Store,
    private titleCasePipe: TitleCasePipe,
  ) {
    this.handleUpload = this._handleUpload.bind(this);
  }

  _handleUpload(files: FileList) {
    const contactId = this.contact?.id,
      category = this.category,
      borrowerId = this.borrowerId() as number;
    forEach(files, file => {
      file['contactId'] = contactId;
      file['category'] = category;
      file['years'] = [this.requirement.year];
      this.store.dispatch( new UploadDocument(file, borrowerId));
    });
  }

  assignDocumentToRequirement(document: Document) {
    const contactId = this.contact?.id || document.contactId;
    this.store.dispatch( new UpdateDocument({
      ...document,
      yearsString: this.requirement.year.toString(),
      years: [this.requirement.year.toString()],
      category: this.category,
      contactId,
    }));
  }

  pushDocumentToFlashSpread(documentId: number) {
    this.store.dispatch( new PushToFlashSpread(documentId) );
  }
}
